import { Component } from '@angular/core';
import { IAlert } from './alert.interfaces';
import { AlertService } from '@shared/toolkit/services/alert/alert.service';

@Component({
	selector: 'ipb-alert-container',
	templateUrl: './alert-container.component.html',
	styleUrls: ['./alert-container.component.scss'],
})
export class AlertContainerComponent {
	constructor(private readonly alertService: AlertService) {}

	public get alert(): IAlert {
		return this.alertService.alertState ?? {};
	}
}
